import styled from 'styled-components'

import { COLORS } from 'consts/colors'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

export const RefillButton = styled.button`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  height: 34px;
  font-size: 16px;
  font-weight: 500;
  background: ${COLORS.primaryExtraLight};

  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s;

  & > .credits-count {
    font-weight: 600;
    font-size: 16px;
    color: ${COLORS.secondarySemiDark};
    margin-left: 4px;

    @media only screen and (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
      font-size: 14px;
      max-width: 39px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  & > .credits-label {
    margin-left: 8px;
    font-size: 16px;
    font-weight: 700;
    background: linear-gradient(
        90deg,
        rgb(47, 135, 254) 0%,
        rgb(214, 150, 206) 50%,
        rgb(34, 20, 228) 100%
      )
      text;
    -webkit-text-fill-color: transparent;

    @media only screen and (max-width: 1620px) {
      display: none;
    }
  }

  &:hover {
    background: ${COLORS.primaryLight};

    & > .credits-label {
      background: linear-gradient(
          90deg,
          rgb(34, 20, 228) 0%,
          rgb(214, 150, 206) 50%,
          rgb(47, 135, 254) 100%
        )
        text;
    }
  }
`
